<style>
    .overflow-hidden { overflow: hidden; }
    .outer { position: relative; left: 50%; float: left; }
    .inner { position: relative; left: -50%; float: left; }
    .hidden {
        display: none;
    }

    .log-table thead th, .log-table tbody td{
        padding: 0 .75rem;
        vertical-align: middle;
        border: none;
    }
    .log-table tr {
        border-top: 1px solid #91ccda;
        padding: 16px;
    }
    .log-table tr:first-child {
        border-top: none;
    }

    .log-table tr:hover {
        background-color: #ebf5f8;
    }

    .log-table tr td {
        color: #223264;
        border: none;
    }

    .log-table tr.table-details {
        border-top: 0px;
        border-bottom: solid 1px #91ccda;
    }
    .log-table tr.table-details:last-child {
        border-bottom: none;
    }

    .log-table tr.table-details:hover,
    .log-table tr.table-has-details:hover {
        background-color: transparent;
    }

    .log-table tr td {
        cursor: pointer;
    }
    .log-table tr.table-details td {
        cursor: initial;
    }

    #main_content .log-table td p {
        font-size: 16px;
    }

    .smaller-icon-container {
        font-size: .725em;        
    }
</style>

<template>
    <div class="component-container">
        <div class="log-table table-responsive">
            <div v-if="orderedLogs.length == 0">
                <span>There are no activity logs for this childcare program</span>
            </div>
            <table v-else class="table">
                <thead class="hidden">
                    <tr>
                        <th v-for="field in fields" :style="field.thStyle">{{ field.key }}</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(log, logIndex) in paginatedItems">
                        <tr @click.stop="toggleDetails[logIndex] = !toggleDetails[logIndex]">
                            <td><strong>{{ log.type.name }}</strong></td>
                            <td>{{ log.user.first_name }} {{log.user.last_name}}</td>
                            <td>{{ formatDate(log.date) }}</td>
                            <td>
                                <div class="col text-right">
                                    <div class="smaller-icon-container" v-show="!toggleDetails[logIndex]">
                                        <span class="fa fa-plus"></span>
                                    </div>
                                    <div class="smaller-icon-container" v-show="toggleDetails[logIndex]">
                                        <span class="fa fa-minus"></span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="toggleDetails[logIndex]">
                            <td class="details" colspan="4">
                                <p>Time Spent: <strong>{{log.time_spent}} minutes</strong></p>
                                <p>Areas Covered: <strong>{{log.areaString}}</strong></p>
                                <p>{{log.notes}}</p>
                                <button type="button" class="btn btn-orange-blue" v-on:click="assignLog(log)" data-toggle="modal" data-target="#activityLogFormModal">
                                    Edit
                                </button>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>

        <div class="overflow-hidden">
            <div class="outer">
                <div class="row justify-content-center">
                    <nav aria-label="Page navigation for list of Connected Programs">
                        <ul class="pagination" role="menubar">
                            <li class="page-item">
                                <a class="page-link" @click="prevPage" aria-label="Go to previous page">&lt;</a>
                            </li>
                            <li v-for="pageNum in pageCount" class="page-item" :class="{active: pageNum == currentPage}" :aria-label="`Go to page ${pageNum}`">
                                <a class="page-link" @click="setPage(pageNum)">{{ pageNum }}</a>
                            </li>
                            <li class="page-item">
                                <a class="page-link" @click="nextPage" aria-label="Go to next page">&gt;</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapWritableState } from 'pinia'
    import { useConsultantsStore } from './store.js';

    export default {
        props: {
            logs: {
                required: true,
                type: Array
            }
        },
        data() {
            return {
                perPage: 5,
                currentPage: 1,
                fields: [
                    {
                        key: 'type',
                        thStyle: {
                            width: '40%'
                        },
                        label: ''
                    }, 
                    {
                        key: 'user',
                        thStyle: {
                            width: '20%'
                        },
                        label: ''
                    }, 
                    {
                        key: 'date',
                        thStyle: {
                            width: '20%'
                        },
                        label: ''
                    }, 
                    {
                        key: 'show_details',
                        label: ''
                    }
                ],
                toggleDetails: {}
            }
        },
        methods: {
            formatDate(dateString, format = 'MM/DD/YY') {
                if (moment(dateString).isValid()) {
                    return moment(dateString).utc().format(format)
                }
                return null
            },
            assignLog(log) {
                this.currentLog = {...this.currentLog, ...log};
            },
            setPage: function(page) {
                this.currentPage = page;
            },
            nextPage: function() {
                if(this.currentPage >= this.pageCount) {
                    this.currentPage = this.pageCount;
                } else {
                    this.currentPage++;
                }
            },
            prevPage: function() {
                if(this.currentPage <= 1) {
                    this.currentPage = 1;
                } else {
                    this.currentPage--;
                }
            },
        },
        computed: {
            totalRows: function () {
                return this.logs.length
            },
            orderedLogs: function () {
                return this.logs.sort((a,b) => {
                    const aStamp = moment(a.date).unix();
                    const bStamp = moment(b.date).unix();

                    if (aStamp == bStamp) {
                        return 0;
                    } else if (aStamp > bStamp) {
                        return 1;
                    } else {
                        return -1
                    }
                });
            },
            pageCount: function() {
                return Math.ceil(this.orderedLogs.length/this.perPage);
            },
            paginatedItems: function() {
                let start = (this.currentPage-1) * this.perPage;
                return this.orderedLogs.slice(start, start + this.perPage);
            },
            ...mapWritableState(useConsultantsStore, {
                currentLog: 'log',
            }),
        },
        mounted() {
        }
    }
</script>